/* eslint-disable max-len */

// import { Snackbar, Alert } from '@mui/material';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { trackNumberTest } from '@/utils';
import { Form, message, Button } from 'antd';
import { fulfilledTracking } from '@api';
// import { getPackageData } from '@/hooks';
import classes from './index.module.css';
import { Panel } from '../panel';
import { CheckBoxItem } from '../choose';
import { TrackingFormItem } from '../track-form';
import { Tag } from '../common';
import { BorderModal } from '../modals';

/**
 *
 * @param {Boolean} open modal 是否展示
 * @param {Function} handleClose modal 关闭事件
 * @param {Function} handleOK modal 点击确定后回调事件
 * @param {String} currentFulfillmentId 当前包裹的fulfillmentId 有值代表从已发货的item/button点击过来，无值从未发货点击过来，需要展示unfulfillment信息
 * @returns
 */
export const ModalForNoTrackNumber = ({
  open, handleClose, handleOK, currentFulfillmentId,
}) => {
  const [selected, setSelected] = useState([]);
  const [disabled, setDisabled] = useState(true);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const { unFulfilledItems, policyId } = useSelector((store) => store.claim);

  const onValuesChange = (value, values, items) => {
    let flag = false;
    Object.values(values).forEach((item) => {
      if (!item) {
        flag = true;
      }
    });
    if (!trackNumberTest(values.trackingNumber)) {
      flag = true;
    }
    if (items?.length === 0) {
      flag = true;
    }
    if (flag !== disabled) {
      setDisabled(flag);
    }
  };
  const handleChange = (event, packageIndex, index, item) => {
    console.log(packageIndex, index, item);
    const { checked, value } = event.target || {};
    const tempSelected = [...selected];
    if (!checked) {
      const index = selected.findIndex((item) => item === value);
      if (index === -1) {
        return;
      }
      tempSelected.splice(index, 1);
      if (!selected.length) {
        setDisabled(true);
      }
    } else {
      tempSelected.push(value);
    }
    setSelected(tempSelected);
  };

  const onClickContinue = async () => {
    setLoading(true);
    const formValues = form.getFieldsValue();
    const { trackingNumber, carrier } = formValues;
    const items = [];
    const params = {
      policyId,
      trackingNumber,
      carrier,
    };
    if (currentFulfillmentId) {
      params.fulfillmentId = currentFulfillmentId;
    } else {
      unFulfilledItems.forEach((item, index) => {
        if (selected.includes(`${item.lineItemId}__0__${index}`)) {
          items.push({
            lineItemId: item.lineItemId,

          });
        }
      });
      params.items = items;
    }

    try {
      const { code } = await fulfilledTracking(params);
      if (code === 0) {
        // await getPackageData({ policyId, issueType: type }, dispatch, navigate);
        handleOK();
      } else {
        message.error('Something went error, please try again');
      }
    } catch (e) {
      console.log(e);
    }
    setLoading(false);
  };
  const getUnfulfilledBlock = () => {
    if (!unFulfilledItems?.length) {
      return null;
    }
    return (
      <Panel className={classes.unful_panel}>
        <Tag
          color="#FFEA8A"
          text="Unfulfilled"
        />
        {unFulfilledItems.map((item, index) => (
          <CheckBoxItem
            packageIndex="0"
            key={item.lineItemId}
            item={item}
            index={index}
            handleChange={handleChange}
            selectedItems={selected}
          />
        ))}
      </Panel>
    );
  };
  const close = () => {
    handleClose();
  };

  const isDisbled = (!currentFulfillmentId && !selected.length) || disabled;
  return (
    <BorderModal
      open={open}
      centered
      title=" Add Shipping Information"
      onCancel={close}
      footer={[
        <Button key="back" onClick={close}>
          Cancel
        </Button>,
        <Button key="submit" type="primary" onClick={onClickContinue} disabled={isDisbled || loading} loading={loading}>
          Add
        </Button>,
      ]}
    >
      <Form
        name="trackingForm"
        layout="vertical"
        onValuesChange={onValuesChange}
        className={classes.trackingForm}
        form={form}
      >
        {!currentFulfillmentId && getUnfulfilledBlock()}
        <div>
          <div className={classes.track_wrapper}>
            <TrackingFormItem form={form} />

          </div>
        </div>
      </Form>
    </BorderModal>
  );
};
